import { render, staticRenderFns } from "./AutoComplete.vue?vue&type=template&id=bcb822f6&scoped=true"
import script from "./AutoComplete.vue?vue&type=script&lang=js"
export * from "./AutoComplete.vue?vue&type=script&lang=js"
import style0 from "../styles/autocomplete.css?vue&type=style&index=0&id=bcb822f6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb822f6",
  null
  
)

export default component.exports